module.exports = __webpack_public_path__ + "assets/img/4_74_big.01d95659.jpg";